import MemoryStorage from '../lib/memory';

const cache = new MemoryStorage();

export default cache;